import styles from './ModalFooter.module.css';

type Props = {
  children: React.ReactNode;
  justify?: 'start' | 'end' | 'stretch';
};

export function ModalFooter({ children, justify = 'end' }: Props) {
  return (
    <div className={`${styles.ModalFooter} ${styles[`ModalFooter___${justify}Justify` as const]} `}>{children}</div>
  );
}
